<template>
  <div class="showTheLogin">
    <div class="loginCent">
      <nav>
        <div class="hiddenLoginBtn">
          <img src="@/assets/images/Icon/CloseOutlined.png" @click="hiddenLoginBtn" alt="">
        </div>
      </nav>
      <div class="loginForm">
        <div class="loginFormBox">
          <!-- 登录方式切换 Tabs -->
          <el-tabs v-if="isRegistered === '2'" v-model="activeLoginTab" class="login-tabs">
            <el-tab-pane label="短信登录" name="code">
              <el-form :model="smsLoginForm" :rules="smsLoginRules" ref="smsLoginForm">
                <div class="inputBox">
                  <el-form-item prop="userName">
                    <el-input v-model="smsLoginForm.userName" maxlength="11" placeholder="请输入您的手机号码">
                      <template slot="prefix">
                        <div>
                          +86
                          <img src="@/assets/images/Icon/DownOutlined.png" alt="">
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="verificationCode">
                    <el-input v-model="smsLoginForm.verificationCode" placeholder="请输入验证码"
                      @keyup.enter.native="handleSmsLogin">
                    </el-input>
                    <el-button v-show="codeShow" type="text" class="codeBtn" @click="getCode('sms')"
                      v-throttle>获取验证码</el-button>
                    <el-button v-show="!codeShow" type="text" class="codeBtn codeCount" v-throttle>重新获取({{ codeCountNum
                    }}s)</el-button>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
            <el-tab-pane label="密码登录" name="password">
              <el-form :model="passwordLoginForm" :rules="passwordLoginRules" ref="passwordLoginForm">
                <div class="inputBox">
                  <el-form-item prop="userName">
                    <el-input v-model="passwordLoginForm.userName" maxlength="11" placeholder="请输入您的手机号码">
                      <template slot="prefix">
                        <div>
                          +86
                          <img src="@/assets/images/Icon/DownOutlined.png" alt="">
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="password">
                    <el-input v-model="passwordLoginForm.password" placeholder="请输入密码" show-password
                      @keyup.enter.native="handlePasswordLogin">
                    </el-input>
                  </el-form-item>
                </div>
              </el-form>
            </el-tab-pane>
          </el-tabs>

          <div v-else-if="isRegistered === '1'">
            <div class="loginTitle">
              <div class="title text_c mb_32">用户注册</div>
            </div>
            <el-form :model="registerForm" :rules="registerRules" ref="registerForm">
              <div>
                <div class="inputBox">
                  <el-form-item prop="userName">
                    <el-input v-model="registerForm.userName" maxlength="11" placeholder="请输入您的手机号码">
                      <template slot="prefix">
                        <div>
                          +86
                          <img src="@/assets/images/Icon/DownOutlined.png" alt="">
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="verificationCode">
                    <el-input v-model="registerForm.verificationCode" placeholder="请输入验证码"
                      @keyup.enter.native="handleRegister">
                    </el-input>
                    <el-button v-show="codeShow" type="text" class="codeBtn" @click="getCode('register')"
                      v-throttle>获取验证码</el-button>
                    <el-button v-show="!codeShow" type="text" class="codeBtn codeCount" v-throttle>
                      重新获取({{ codeCountNum }}s)</el-button>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="password">
                    <el-input v-model="registerForm.password" placeholder="请输入密码" show-password
                      @keyup.enter.native="handleRegister">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="confirmPassword">
                    <el-input v-model="registerForm.confirmPassword" placeholder="请再次输入密码" show-password
                      @keyup.enter.native="handleRegister">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>
          <div v-else-if="isRegistered === '3'">
            <div class="loginTitle">
              <div class="title text_c mb_32">忘记密码</div>
            </div>
            <el-form :model="forgotPasswordForm" :rules="forgotPasswordRules" ref="forgotPasswordForm">
              <div>
                <div class="inputBox">
                  <el-form-item prop="userName">
                    <el-input v-model="forgotPasswordForm.userName" maxlength="11" placeholder="请输入您的手机号码">
                      <template slot="prefix">
                        <div>
                          +86
                          <img src="@/assets/images/Icon/DownOutlined.png" alt="">
                        </div>
                      </template>
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="verificationCode">
                    <el-input v-model="forgotPasswordForm.verificationCode" placeholder="请输入验证码"
                      @keyup.enter.native="handleForgotPassword">
                    </el-input>
                    <el-button v-show="codeShow" type="text" class="codeBtn" @click="getCode('forgotPassword')"
                      v-throttle>获取验证码</el-button>
                    <el-button v-show="!codeShow" type="text" class="codeBtn codeCount" v-throttle>
                      重新获取({{ codeCountNum }}s)</el-button>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="password">
                    <el-input v-model="forgotPasswordForm.password" placeholder="请输入新密码" show-password
                      @keyup.enter.native="handleForgotPassword">
                    </el-input>
                  </el-form-item>
                </div>
                <div class="inputBox">
                  <el-form-item prop="confirmPassword">
                    <el-input v-model="forgotPasswordForm.confirmPassword" placeholder="请再次输入新密码" show-password
                      @keyup.enter.native="handleForgotPassword">
                    </el-input>
                  </el-form-item>
                </div>
              </div>
            </el-form>
          </div>

          <div class="noLogin" v-if="isRegistered === '2'">
            <el-checkbox class="checkbox_584dff" v-model="isNoLogin">七天免登录</el-checkbox>
            <!-- <div @click="denglu">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</div> -->
          </div>

          <div class="loginProtocol" v-if="isRegistered === '1'">
            <el-form :model="protocolForm" :rules="protocolRules" ref="protocolForm">
              <el-form-item prop="agreed">
                <el-checkbox class="checkbox_584dff" v-model="protocolForm.agreed">阅读并同意</el-checkbox>
                <span class="backgroundColor_584DFF cur_p" @click="readAgreement">《有有宝商城 服务协议》</span>
              </el-form-item>
            </el-form>
          </div>

          <el-button class="loginBtn" @click="handleSubmit" :loading="loadingLogin">
            {{ isRegistered === '1' ? '注册' : isRegistered === '2' ? '登录' : '确定修改' }}
          </el-button>

          <div class="flex_j_c gap_6">
            <div class="flex_a_c fontS_14 gap_4">
              <img src="@/assets/images/Icon/Alipay.png" alt="">
              <span class="color_4B5B76 cur_p">支付宝{{ isRegistered === '1' ? '注册' : '登录' }}</span>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="flex_a_c fontS_14 gap_4">
              <img src="@/assets/images/Icon/WeChat.png" alt="">
              <span class="color_4B5B76 cur_p">微信{{ isRegistered === '1' ? '注册' : '登录' }}</span>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="flex_a_c fontS_14 gap_4">
              <span class="color_4B5B76 cur_p" @click="registered">{{ isRegistered === '2' ? '立即注册' : '立即登录' }}</span>
            </div>
            <el-divider direction="vertical"></el-divider>
            <div class="flex_a_c fontS_14 gap_4">
              <span class="color_4B5B76 cur_p" @click="forgotPasswordClick">忘记密码</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <el-dialog title="服务协议" :visible.sync="dialogAgreement" width="50%">
      <h1 class="text_c fontW_b fontSize_30 mb_10">有有宝商城用户服务协议</h1>

      欢迎您使用有有宝商城的服务！本协议是您与本商城运营方（以下简称 “我们”）之间就使用本商城服务所订立的协议，具有法律效力，请您仔细阅读并充分理解本协议的各项条款。

      <h1 class="agreementTitle">一、协议的确认与接受</h1>

      1.在使用本商城服务前，请您认真阅读、充分理解本协议的全部内容，特别是限制或免除责任的条款（包括法律适用与管辖条款），该类条款将以加粗和 / 或加下划线等显著形式提示您注意。您点击 “同意”
      按钮，或实际使用本商城服务的行为，均视为您已阅读、理解并接受本协议的全部内容，本协议即构成对双方具有约束力的法律文件并立即生效。若您不同意本协议条款，您有权停止使用本商城服务。<br />

      2.本协议范围包括我们现在或将来制定的与本商城服务相关的其他协议、规范、规则、公告声明等，如商城平台公告、隐私政策、账号使用协议等。如内容不一致或矛盾的，以专门适用于某个业务场景的协议条款为准。您使用本商城服务，视为您同意上述所有协议。<br />

      3.我们有权根据业务发展需求及法律规定，修改本协议及相关协议条款。更新后的协议条款将在相关服务页面公布，并在法律规定的期限届满后正式生效。若协议条款有实质或重大变更，我们将通过您提供的电子邮件或推送公告等方式通知您。协议变更后，您继续使用本商城服务，即视为您已接受修改后的协议；若您不接受，您有权停止使用服务。<br />

      <h1 class="agreementTitle">二、使用有有宝商城服务的要求</h1>

      1.年龄限制：您应确保在下载本商城应用和 / 或使用本商城服务时已年满 18 周岁，或虽未年满 18 周岁，但已年满 16
      周岁并能以自己的劳动收入为主要生活来源。若不符合上述条件，您应在监护人陪同下阅读本协议，在监护人同意之前，请勿使用本商城服务。同时，我们建议监护人对未成年人使用互联网及相关设备和应用程序的行为进行监管和指导。若您已下载和 /
      或使用本商城服务，我们将根据法律规定推定您具备相应民事行为能力或已经过监护人同意，您的行为由您或您的监护人承担法律后果，但有相反证据足以推翻的除外。<br />

      2.对象限制：您需确保您不是任何国家、国际组织或者地域实施的贸易限制、制裁或其他法律、规则限制的对象，否则可能无法正常注册及使用本商城服务。<br />

      3.企业或单位购买：如需代表特定企业或单位在本商城购买商品或享受服务，您须按照我们的要求提交企业或单位的相关证件及授权材料。若不符合前述条件，本商城将无法为您提供服务，因此给本商城或第三方造成损失的，您须承担相应赔偿责任。<br />

      4.装置与兼容性：使用本商城服务可能需要互联网相关装置、接入或某些软件，并可能产生相关费用。您可通过预装、我们已授权的第三方下载等方式获取本商城客户端应用程序或访问本商城相关网站，使用本商城及相关服务。若非通过上述方式进入本商城，我们无法保证客户端应用程序或网站能正常使用，您因此遭受的损失与我们无关。您需自行配备上网设备，负担网络接入费、手机流量费等服务费用。<br />

      5.使用限制：您同意仅基于本商城服务许可目的使用本商城服务。若您对本商城服务的使用或其他行为威胁到我们提供本商城服务或其他系统的能力，或我们通过技术判断发现您的账号 /
      行为存在异常，我们有权采取一切合理措施保护本商城服务，包括暂停或终止您访问或使用本商城服务。如您屡次违反限制，可能导致本商城为您提供的服务被终止。<br />

      <h1 class="agreementTitle">三、有有宝商城服务</h1>

      1.购买商品<br />
      ◦商品信息：本商城的商品或服务信息可能随时变动，商城页面中的文字表述、图片效果等可能被实时修改和调整，此类变化和调整可能不作特别通知。商城内展示的商品规格参数、功能说明、零部件信息、库存、限购数量等商品信息将尽量准确、详细并与实际产品信息匹配，但可能存在误差。<br />

      ◦商品价格：本商城对商品明码标价，但商品价格信息可能随时变动，商品成交价格以您提交订单结算时的价格为准。我们将尽量确保商品价格准确，但无法避免您提交的订单信息中的商品出现价格标示错误的情况；如您下单所购买商品的正确定价高于商城网站显示的定价，或由于系统错误导致订单价格有误，我们有权咨询您的意见，并根据具体情况取消您的订单、解除合同并通知您。<br />

      ◦合同订立：本商城展示的商品和价格等信息为要约邀请，您的订单将成为订购商品的要约。下订单时，请仔细确认所购商品的名称、价格、数量、型号、规格、尺寸、联系地址、电话、收货人等信息，确认无误后提交订单。您在本商城提交订单并付清全款后，视为您与我们就已付款的商品建立了合同关系。在买卖合同成立前，您与我们均有权取消相关产品的订单。<br />

      ◦先款后货：本商城实行先付款后发货的方式，您及时、足额、合法地支付选购商品所需的货款是发货的必要条件，如您未在指定时间以合理方式完成付款，视为合同未成立，我们有权取消该笔订单。<br />

      ◦缺货免责：在合同成立前，本商城展示的预计发货或到货信息为参考信息，我们将在合同成立后根据实际供货及物流情况派送商品。我们将尽量满足您的选购需求，但无法保证您提交的订单信息中的商品不会出现缺货的情况。如您下单所购买的商品缺货，您有权取消订单、解除合同，我们亦有权自行取消订单、解除合同，若您已经付款，则为您办理退款。订单取消后，您已支付的款项将尽快退回您的付款账户，退款时间因支付平台与方式的不同会存在差异。<br />

      ◦禁止恶意下单：基于维护本商城交易秩序的需要，若发生以下任一情形，我们有权采取包括但不限于单方面取消订单和解除交易合同、删除账号等措施，若您已经付款，则为您办理退款。同时，我们保留追究违约用户法律责任的权利：

      ▪您利用软件、技术手段、拆单或其他方式，为购买超过限购数量的商品或套取优惠、折扣、赠品、运费或其他利益，使用一个账号或多个账号在同一时间段内批量下单。<br />

      ▪您的订单行为被我们合理怀疑存在异常，可能损害本商城或其他用户的合法权益。<br />

      1.售后服务：我们将按照相关法律法规及本商城公布的售后服务政策，为您提供商品退换货、质量保证等售后服务。具体售后服务内容及流程，请查看本商城相关页面说明。如您在售后服务过程中与我们发生争议，可通过本商城提供的客服渠道进行沟通协商，我们将尽力解决您的问题。<br />

      <h1 class="agreementTitle">四、用户账号</h1>

      1.注册与使用：您在注册账号时，应提供真实、准确、完整的个人信息，并确保信息在使用本商城服务期间保持有效。您应对您账号下的所有行为负责，不得将账号转借、出租、出售给他人使用。若发现账号被他人非法使用，您应立即通知我们，并协助我们进行处理。<br />

      2.账号安全：您有责任妥善保管账号及密码，防止账号信息泄露。如因您自身原因导致账号密码泄露，进而造成账号被盗用或遭受损失的，您应自行承担相关后果。我们将采取合理的技术和管理措施保护您的账号安全，但对于因不可抗力、网络攻击、系统故障等不可预见、不可避免的原因导致的账号安全问题，我们不承担责任。<br />

      3.账号注销：您有权向我们申请注销账号，我们将在收到申请并核实相关信息后，按照相关规定为您办理账号注销手续。账号注销后，您将无法再使用该账号登录本商城，且账号内的所有信息（包括但不限于订单记录、积分、优惠券等）将被删除或匿名化处理，无法恢复，请您谨慎操作。<br />

      <h1 class="agreementTitle">五、隐私政策</h1>

      1.我们非常重视您的个人信息保护，将按照本商城公布的隐私政策收集、使用、存储和保护您的个人信息。隐私政策是本协议的重要组成部分，您在使用本商城服务前，应仔细阅读并理解隐私政策的内容。<br />

      2.您同意我们按照隐私政策的规定，收集、使用您在注册、使用本商城服务过程中提供的个人信息，以便为您提供更好的服务体验，包括但不限于商品推荐、个性化服务、客户支持等。同时，我们将采取合理的安全措施保护您的个人信息安全，防止信息泄露、丢失或被滥用。<br />

      <h1 class="agreementTitle">六、知识产权</h1>

      1.本商城的所有内容，包括但不限于文字、图片、图表、音频、视频、软件、程序、商标、标识等，均受知识产权法律的保护，其知识产权归我们或相关权利人所有。未经我们或相关权利人书面许可，您不得擅自复制、传播、修改、出售、出租、许可他人使用或以其他任何方式侵犯本商城的知识产权。<br />

      2.您在本商城发布的任何内容（如评论、晒单等），您授予我们在全球范围内、永久的、不可撤销的、非独家的、可再许可的权利，以使用、复制、修改、改编、出版、翻译、据以创作衍生作品、传播、表演和展示这些内容，以及将这些内容编入其他任何形式的作品、媒体或技术中。同时，您保证您发布的内容不侵犯任何第三方的知识产权或其他合法权益。<br />

      <h1 class="agreementTitle">七、责任限制与免责声明</h1>

      1.在适用法律允许的最大范围内，我们对本商城服务不提供任何明示或默示的保证，包括但不限于对服务的可用性、准确性、完整性、可靠性、适销性、特定用途适用性的保证。因使用本商城服务而导致的任何直接、间接、偶然、特殊、惩罚性或后果性损失，我们不承担责任，但因我们故意或重大过失造成的损失除外。<br />

      2.对于因不可抗力、政府行为、第三方原因（如网络服务提供商故障、电信部门技术调整等）、系统维护或升级等原因导致的本商城服务中断、延迟、错误或无法使用，我们不承担责任，但我们将尽力减少此类情况对您造成的影响，并在合理时间内恢复服务。<br />

      3.您明确理解并同意，使用本商城服务所存在的风险由您自行承担。如您因使用本商城服务遭受任何损失或损害，您应自行负责处理并承担相应后果，我们对此不承担任何责任。<br />

      <h1 class="agreementTitle">八、协议的终止</h1>

      1.您有权随时停止使用本商城服务，并可通过本商城提供的渠道申请注销账号，本协议自您账号注销成功时终止。<br />

      2.若您违反本协议的任何条款，我们有权不经通知立即终止本协议，并停止向您提供本商城服务，同时有权删除您的账号及账号内的所有信息。在协议终止后，不影响我们对您在协议存续期间违反本协议行为追究法律责任的权利。<br />

      3.本协议终止后，您应立即停止使用本商城服务，且不得再以任何方式使用本商城的内容和服务。如您在协议终止后继续使用本商城相关内容或服务，我们有权追究您的侵权责任。<br />

      <h1 class="agreementTitle">九、法律适用与争议解决</h1>

      1.本协议的签订、履行、解释及争议解决均适用中华人民共和国法律（不包括冲突法）。<br />

      2.如您与我们之间因本协议或使用本商城服务发生争议，应首先通过友好协商解决；协商不成的，任何一方均有权向本商城运营方所在地有管辖权的人民法院提起诉讼。<br />

      <h1 class="agreementTitle">十、其他条款</h1>

      1.本协议的标题仅为方便阅读而设，不具备法律约束力。<br />

      2.若本协议的任何条款被认定为无效、违法或不可执行，不影响其他条款的有效性、合法性和可执行性，其他条款应继续有效并履行。<br />

      3.我们未行使或执行本协议任何权利或条款，不构成对该权利或条款的放弃。我们对本协议任何条款的放弃，必须以书面形式作出，并明确表示放弃该条款的权利。<br />

      4.本协议构成您与我们之间就使用本商城服务的完整协议，取代之前所有关于本商城服务的口头或书面协议。<br />

      请您再次确认已仔细阅读并充分理解本协议的所有内容，如有任何疑问，请随时联系我们的客服人员。使用有有宝商城服务即视为您接受本协议的约束，希望您在有有宝商城拥有愉快的购物体验！

    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import store from '@/store/index.js'
import {
  getCodeBefore,
  getTheCode,
  login,
  unifiedLogin,
  forgetPassword
} from '@/api/login.js'
import {
  getUserInfo
} from '@/api/user/user.js'

export default {
  name: 'login',
  data () {
    // 手机号校验规则
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入手机号'))
      }

      // 清除空格和横线
      const phone = value.replace(/[\s-]/g, '')

      // 长度校验
      if (phone.length !== 11) {
        return callback(new Error('手机号码长度应为11位'))
      }

      // 数字校验
      if (!/^\d+$/.test(phone)) {
        return callback(new Error('手机号码只能包含数字'))
      }

      // 格式校验
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        return callback(new Error('请输入正确的手机号码'))
      }

      callback()
    }

    // 验证码校验规则
    const validateCode = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入验证码'))
      }
      if (!/^\d{4,6}$/.test(value)) {
        return callback(new Error('验证码格式不正确'))
      }
      callback()
    }

    // 密码校验规则
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入密码'))
      }
      if (value.length < 6) {
        return callback(new Error('密码长度不能少于6位'))
      }
      callback()
    }

    // 协议同意校验规则
    const validateAgreed = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请阅读并同意服务协议'))
      }
      callback()
    }
    // 添加确认密码校验规则
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再次输入新密码'))
      }
      if (value !== this.forgotPasswordForm.password) {
        return callback(new Error('两次输入的密码不一致'))
      }
      callback()
    }
    // 添加确认密码校验规则
    const validateConfirmPasswordRegister = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请再次输入新密码'))
      }
      if (value !== this.registerForm.password) {
        return callback(new Error('两次输入的密码不一致'))
      }
      callback()
    }

    return {
      activeLoginTab: 'code',
      isNoLogin: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2',
      loadingLogin: false,
      timer: null,

      // 短信登录表单
      smsLoginForm: {
        userName: '',
        verificationCode: ''
      },
      smsLoginRules: {
        userName: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ]
      },

      // 密码登录表单
      passwordLoginForm: {
        userName: '',
        password: ''
      },
      passwordLoginRules: {
        userName: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ]
      },

      // 注册表单
      registerForm: {
        userName: '',
        verificationCode: '',
        password: '',
        confirmPassword: ''
      },
      registerRules: {
        userName: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPasswordRegister, trigger: 'blur' }
        ]
      },

      // 协议表单
      protocolForm: {
        agreed: false
      },
      protocolRules: {
        agreed: [
          { required: true, validator: validateAgreed, trigger: 'change' }
        ]
      },
      // 忘记密码表单
      forgotPasswordForm: {
        userName: '',
        verificationCode: '',
        password: '',
        confirmPassword: ''
      },
      forgotPasswordRules: {
        userName: [
          { required: true, validator: validatePhone, trigger: 'blur' }
        ],
        verificationCode: [
          { required: true, validator: validateCode, trigger: 'blur' }
        ],
        password: [
          { required: true, validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { required: true, validator: validateConfirmPassword, trigger: 'blur' }
        ]
      }
    }
  },
  filters: {
  },

  methods: {
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        store.commit('SET_USERINFO', res.data)
      }
    },

    // 获取验证码
    async getCode (formType) {
      let phone = ''

      // 根据不同表单类型获取手机号
      if (formType === 'sms') {
        phone = this.smsLoginForm.userName
      } else if (formType === 'register') {
        phone = this.registerForm.userName
      } else if (formType === 'forgotPassword') {
        phone = this.forgotPasswordForm.userName
      } else {
        // 默认使用当前激活的登录方式
        if (this.activeLoginTab === 'code') {
          phone = this.smsLoginForm.userName
        } else {
          phone = this.passwordLoginForm.userName
        }
      }

      // 校验手机号
      if (!/^1[3-9]\d{9}$/.test(phone)) {
        this.$message({
          message: '手机号格式错误',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      getCodeBefore({phone})
      const response = await getTheCode({ phone })
      const res = response.data
      if (res.code === '200') {
        const TIME_COUNT = 120
        if (!this.timer) {
          this.codeCountNum = TIME_COUNT
          this.codeShow = false
          this.timer = setInterval(() => {
            if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
              this.codeCountNum--
            } else {
              this.codeShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        this.$message({
          message: '验证码获取成功',
          type: 'success',
          customClass: 'messageZindex'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },

    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },

    // 处理表单提交
    handleSubmit () {
      if (this.isRegistered === '1') {
        // 注册表单提交
        this.handleRegister()
      } else if (this.isRegistered === '3') {
        // 忘记密码表单提交
        this.handleForgotPassword()
      } else {
        // 登录表单提交
        if (this.activeLoginTab === 'code') {
          this.handleSmsLogin()
        } else {
          this.handlePasswordLogin()
        }
      }
    },

    // 短信登录
    handleSmsLogin () {
      this.$refs.smsLoginForm.validate((valid) => {
        if (valid) {
          this.getLogin('sms')
        }
      })
    },

    // 密码登录
    handlePasswordLogin () {
      this.$refs.passwordLoginForm.validate((valid) => {
        if (valid) {
          this.getLogin('password')
        }
      })
    },

    // 注册
    handleRegister () {
      // 同时验证注册表单和协议表单
      Promise.all([
        new Promise((resolve) => {
          this.$refs.registerForm.validate((valid) => resolve(valid))
        }),
        new Promise((resolve) => {
          this.$refs.protocolForm.validate((valid) => resolve(valid))
        })
      ]).then(([formValid, protocolValid]) => {
        if (formValid && protocolValid) {
          this.getLogin('register')
        }
      })
    },

    // 登录/注册逻辑
    async getLogin (type) {
      this.loadingLogin = true
      let response

      try {
        if (type === 'sms' && this.isRegistered !== '1') {
          response = await login({
            phone: this.smsLoginForm.userName,
            verificationCode: this.smsLoginForm.verificationCode,
            type: this.isRegistered,
            terminal: 5
          })
        } else if (type === 'password' && this.isRegistered !== '1') {
          response = await unifiedLogin({
            phone: this.passwordLoginForm.userName,
            password: this.passwordLoginForm.password,
            type: this.isRegistered,
            loginType: '1',
            terminal: 5
          })
        } else if (type === 'register' && this.isRegistered === '1') {
          response = await unifiedLogin({
            phone: this.registerForm.userName,
            verificationCode: this.registerForm.verificationCode,
            password: this.registerForm.password,
            type: '1',
            loginType: '2',
            terminal: 5
          })
        } else if (type === 'forgotPassword' && this.isRegistered === '3') {
          response = await forgetPassword({
            phone: this.forgotPasswordForm.userName,
            verificationCode: this.forgotPasswordForm.verificationCode,
            password: this.forgotPasswordForm.password,
            newPassword: this.forgotPasswordForm.confirmPassword,
          })
          if (response.data.code === '200') {
            this.$message({
              message: '密码修改成功',
              type: 'success',
              customClass: 'messageZindex',
            })
            this.resetCaptchaTimer()
            this.resetAllForms()
            this.isRegistered = '2'
          } else {
            this.$message({
              message: response.data.message,
              type: 'warning',
              customClass: 'messageZindex',
            })
          }
          return
        }

        const res = response.data
        if (res.code === '200') {
          if (this.isNoLogin) {
            Cookie.set('token', res.data.token, { expires: 7 })
          } else {
            Cookie.set('token', res.data.token, { expires: 1 })
          }
          await this.getUserInfoData()
          this.$message({
            message: '登录成功',
            type: 'success',
            customClass: 'messageZindex'
          })
          store.commit('SHOW_LOGIN')
          store.commit('IS_LOGIN', true)
          location.reload()
        } else {
          this.$message({
            message: res.message,
            type: 'warning',
            customClass: 'messageZindex'
          })
        }
      } catch (error) {
        this.$message({
          message: '网络异常，请稍后重试',
          type: 'error',
          customClass: 'messageZindex'
        })
      } finally {
        this.loadingLogin = false
      }
    },

    registered () {
      this.resetCaptchaTimer()
      this.resetAllForms()
      // 切换注册/登录状态
      this.isRegistered = this.isRegistered === '2' ? '1' : '2'
    },

    // 关闭登录
    hiddenLoginBtn () {
      store.commit('SHOW_LOGIN')
    },
    // 忘记密码
    forgotPasswordClick () {
      this.resetCaptchaTimer()
      this.resetAllForms()
      this.isRegistered = '3'
    },
    // 忘记密码处理
    handleForgotPassword () {
      this.$refs.forgotPasswordForm.validate((valid) => {
        if (valid) {
          // 实现忘记密码逻辑
          this.getLogin('forgotPassword')
        }
      })
    },
    // 重置验证码计时器
    resetCaptchaTimer () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
    },
    // 重置所有表单
    resetAllForms () {
      this.smsLoginForm = { userName: '', verificationCode: '' }
      this.passwordLoginForm = { userName: '', password: '' }
      this.registerForm = { userName: '', verificationCode: '', password: '' }
      this.protocolForm = { agreed: false }
      this.forgotPasswordForm = {
        userName: '',
        verificationCode: '',
        password: '',
        confirmPassword: ''
      }
    },
    // 测试登录
    denglu () {
      this.smsLoginForm.userName = '15111111111'
      this.smsLoginForm.verificationCode = '9999'
      this.getCode('sms')
      this.handleSmsLogin()
    },
  },

  beforeDestroy () {
    // 组件销毁前清除定时器
    if (this.timer) {
      clearInterval(this.timer)
      this.timer = null
    }
  }
}
</script>

<style lang="scss" scoped>
.showTheLogin {
  // height: 100vh;
  // min-height: 768px;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;

  .loginCent {
    // background: url('../../assets/images/beijing.png') no-repeat;
    // flex-grow: 1;
    // background-size: cover;
    width: 528px;
    // height: 448px;
    min-height: 448px;
    border-radius: 12px;
    padding: 24px;
    background-color: #ffffff;
    animation: showRight .5s;
    animation-fill-mode: forwards;
    -webkit-animation-fill-mode: forwards;

    nav {
      .hiddenLoginBtn {
        display: flex;
        justify-content: end;
      }
    }

    .loginForm {
      width: 100%;
      height: 100%;
      background: #ffffff;
      padding: 16px 40px;

      .loginTitle {
        font-family: Microsoft YaHei;
        color: #161A1E;

        .title {
          font-size: 24px;
        }

      }

      .content {
        margin: 10px 0;
        font-size: 14px;
        text-align: center;
        color: #97A3B7;

        u {
          color: $violetColor;
          cursor: pointer;
        }
      }

      .loginFormBox {
        >>>.login-tabs {
          .el-tabs__item {
            font-size: 20px;
            line-height: 28px;
            font-weight: bold;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__active-bar {
            display: none;
          }

          .el-tabs__nav-scroll {
            display: flex;
            justify-content: center;
          }
        }

        .inputBox {
          position: relative;

          .el-input {
            .iconfont {
              font-size: 32px;
              padding: 0 10px;
            }
          }

          >>>.el-input__inner {
            height: 44px;
            background: #F4F8FE;
            border: 0;
            border-radius: 4px;
            font-size: 14px;
            padding: 16px;

          }

          // >>>.el-input__inner:focus {
          //   border-color: $violetColor;
          // }
          &:nth-child(1) {
            >>>.el-input__inner {
              padding-left: 70px;
            }

            >>>.el-input__prefix {
              display: flex;
              align-items: center;
              margin-left: 14px;
            }
          }

          &:nth-child(2) {
            >>>.el-input__inner {
              padding-right: 115px;
            }

          }

          margin: 16px 0 0px 0;

          .codeBtn {
            width: 110px;
            height: 22px;
            display: block;
            line-height: 0px;
            text-align: center;
            position: absolute;
            right: 5px;
            bottom: 10px;
            cursor: pointer;
            background: linear-gradient(7.064707531409216e-7deg, #584DFF 40%, #1866ED 100%);
            background-clip: text;
            color: transparent;
          }

          .codeCount {
            color: #999999;
          }
        }

        .noLogin {
          font-size: 14px;
          margin: 40px 0 16px 0;
          height: 22px;
          align-items: center;
          display: flex;
          justify-content: space-between;

          >>>.el-checkbox__label {
            font-size: 14px;
            font-weight: 400;
            color: #181818;
          }

          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #181818;
          }
        }

        .registered {
          justify-content: flex-end;
        }

        .loginBtn {
          width: 100%;
          height: 44px;
          background: linear-gradient(90deg, #584DFF 40%, #1866ED 100%);
          border-radius: 6px 6px 6px 6px;
          text-align: center;
          font-size: 16px;
          color: #FFFFFF;
          cursor: pointer;
          margin-bottom: 32px;
        }
      }

      .loginProtocol {
        display: flex;
        align-items: center;
        margin: 40px 0 16px 0;
        height: 22px;
        font-size: 14px;
        color: #181818;

        span {
          margin-left: 8px;
        }
      }

      >>>.el-checkbox__inner {
        width: 20px;
        height: 20px;

        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }

  >>>.el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}

.hiddenLogin {
  display: none;
}

@keyframes showRight {
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
}

.agreementTitle {
  font-size: 22px;
  font-weight: bold;
  padding: 3px 0;
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue